import { useLazyQuery, useQuery } from "@apollo/client";
import { PROSPECTIONS } from "../prospection.queries";
import {
  ProspectionsQuery,
  ProspectionsQueryVariables,
} from "../../../__generated__/ProspectionsQuery";

export const useProspections = (variables: ProspectionsQueryVariables) => {
  return useQuery<ProspectionsQuery, ProspectionsQueryVariables>(PROSPECTIONS, {
    variables,
  });
};

export const useLazyProspections = () => {
  return useLazyQuery<ProspectionsQuery, ProspectionsQueryVariables>(PROSPECTIONS);
};
